<template>
  <div>
    <!-- 头部logo -->
    <head-tou />
    <!-- 导航栏 -->
    <navi-gation ref="Childmain" />
    <div class="w">
      <!-- 支付成功 -->
      <div class="paymentOk">
        <img class="img" src="@/assets/pitch.png" alt="" />
        <div>支付成功</div>
        <div v-if="false">
          <div class="ok">支付成功</div>
          <div class="phone">
            请加您的专属老师微信：18956235768为您解决学习中遇到的所有问题。
          </div>
          <div class="serve">服务时间：周一至周五</div>
          <!--                    <el-button>我要开发票</el-button>-->
        </div>
      </div>
      <!-- 学习 -->
      <div class="study">
        <div class="mobile">
          <div class="tu">
            <div class="title">手机学习方式</div>
            <img src="@/assets/wechat.png" alt="" />
            <div>扫二维码关注公众号，进入学习</div>
          </div>
        </div>
        <div class="computer">
          <div class="diannao">
            <div class="title">电脑学习方式</div>
            <img src="@/assets/computer.png" alt="" />
            <a href="#" @click="handleSkip">请点击进入学习</a>
          </div>
        </div>
      </div>
      <!-- 支付失败 -->
      <!-- <div class="defeated">
              <div>
                <img src="@/assets/defeated.png" alt="" />
                <span>支付失败</span>
                <el-button @click="$router.push('/purchase')">返回重试</el-button>
              </div>
            </div> -->
    </div>

    <!-- 底部 -->
    <navigation-button />

    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div class="success">
        <h3>专属老师微信</h3>
        <p>快扫码添加你的专属老师微信</p>
        <img src="@/assets/teacher_wx.png" alt="" class="code" />
        <div>服务时间：周一至周五8:30～17；30</div>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTou from "@/components/hard.vue";
import NavigationButton from "@/components/navigationbutton.vue";
import NaviGation from "@/views/home/components/navigation.vue";

export default {
  name: "paymentOk",
  components: {
    HeadTou,
    NaviGation,
    NavigationButton,
  },
  data() {
    return {
      dialogVisible: false,
      dataTime: "",
    };
  },
  created() {
    this.dataTime = setTimeout(() => {
      this.dialogVisible = true;
    }, 3000);
  },
  beforeDestroy() {
    clearTimeout(this.dataTime);
  },
  methods: {
    handleSkip() {
      this.$router.push("/personal");
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  height: 100px;
  background: #2aa9b5;

  ul {
    width: 1200px;
    height: 100px;
    margin: auto;

    li {
      float: left;
      width: 210px;
      height: 100%;
      line-height: 100px;
      text-align: center;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;

      img {
        margin-left: 10px;
        margin-bottom: 5px;
      }
    }

    li:hover {
      background: #078084;
      width: 210px;
      height: 99px;
      background: #078084;
      opacity: 0.5;
    }

    .login {
      float: right;
      line-height: 100px;
      text-align: center;

      span {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f1eded;
      }

      img {
        position: relative;
        right: 0;
        top: 25px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
  }
}

.w {
  width: 1200px;
  height: 600px;
  margin: 20px auto 30px;
  background-color: #ffffff;
  padding: 20px;

  .paymentOk {
    height: 190px;
    margin-top: 33px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .img {
      width: 80px;
      margin-bottom: 20px;
    }

    .ok {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      margin-bottom: 15px;
      margin-left: 74px;
    }

    .phone {
      height: 13px;
      font-size: 13px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #d8261c;
      margin-bottom: 15px;
      margin-left: 74px;
    }

    .serve {
      height: 13px;
      font-size: 13px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      margin-bottom: 15px;
      margin-left: 74px;
    }

    .el-button {
      margin-left: 74px;
      border: 1px solid #d8261c;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #d8261c;
    }
  }

  .study {
    padding-top: 55px;
    border-top: 1px solid #dcdcdc;
    display: flex;
    position: relative;
    &::after {
      content: "";
      width: 1px;
      background-color: #dcdcdc;
      height: 80%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      margin-top: 55px;
    }

    .mobile {
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      .tu {
        img {
          width: 188px;
          height: 188px;
          margin: 15px 0;
        }
        div {
          font-family: Microsoft YaHei;
          color: #000000;
        }
      }
    }

    .computer {
      flex: 1;
      display: flex;
      justify-content: center;
      text-align: center;
      .diannao {
        width: 188px;
        img {
          width: 188px;
          height: 188px;
          margin: 15px 0;
        }
        a {
          color: #3195fa;
          text-decoration: underline;
        }
      }
    }
    .title {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .defeated {
    margin-top: 33px;
    height: 500px;

    div {
      height: 90px;
      border: 1px solid #dcdcdc;

      img {
        position: relative;
        top: 40%;
        left: 24px;
        transform: translate(0, -50%);
        width: 44px;
        height: 44px;
      }

      span {
        line-height: 90px;
        font-size: 19px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
        margin-left: 65px;
      }

      .el-button {
        position: relative;
        top: 50%;
        right: 30px;
        transform: translate(0, -50%);
        float: right;
        border: 1px solid #d8261c;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d8261c;
      }
    }
  }
}

.success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    margin: 25px 0;
    font-size: 24px;
  }
  p {
    color: #666666;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;
  }
  .code {
    width: 180px;
    margin: 0 0 40px;
  }
}
</style>
